// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"e0970a6f","453":"f9d40f5b","457":"712ff7be","816":"7e27f336","851":"9759d9f4","904":"99892d6c"}[chunkId] + ".chunk.js";
};